// Target-weight helper — used by the on-page BMI card and the PDF report so
// the recommendation stays consistent everywhere.
//
// Logic (WHO Asia-Pacific / Indian consensus cutoffs — matches BMI band UI):
//   BMI < 18.5  → gain to reach BMI 18.5 (lower bound of "Normal")
//   18.5-23     → already healthy → maintain current weight
//   BMI ≥ 23    → lose to reach BMI 23 (upper bound of "Normal")
//
// Returns { targetKg, deltaKg, action }
//   action: "maintain" | "lose" | "gain"
//   deltaKg: positive number of kilograms to lose or gain (0 for maintain)
export function computeTargetWeight(heightCm, weightKg) {
  const h = Number(heightCm);
  const w = Number(weightKg);
  if (!Number.isFinite(h) || h <= 0 || !Number.isFinite(w) || w <= 0) return null;
  const hm = h / 100;
  const bmi = w / (hm * hm);
  let targetBmi;
  let action;
  if (bmi < 18.5) {
    targetBmi = 18.5;
    action = "gain";
  } else if (bmi < 23) {
    return { targetKg: Math.round(w), deltaKg: 0, action: "maintain" };
  } else {
    targetBmi = 23;
    action = "lose";
  }
  const targetKg = Math.round(targetBmi * hm * hm);
  const deltaKg = Math.max(0, Math.round(Math.abs(w - targetKg)));
  return { targetKg, deltaKg, action };
}
